import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { IccIneligibleDrugImportsService } from 'app/core/services/icc/icc-ineligible-drug-imports.service';
import { ImportUploadResult, IccImportUploadComponent } from '../../components/icc-import-upload/icc-import-upload.component';
import { HttpErrorResponse } from '@angular/common/http';
import { isEmpty } from 'lodash-es';
import { ImportNavComponent } from '../../../shared/components/import-nav/import-nav.component';


@Component({
    selector: 'app-icc-import-ineligible-drugs',
    templateUrl: './icc-import-ineligible-drugs.component.html',
    styleUrls: ['./icc-import-ineligible-drugs.component.scss'],
    imports: [ImportNavComponent, IccImportUploadComponent]
})
export class IccImportIneligibleDrugsComponent {
  private ineligibleDrugImportsService = inject(IccIneligibleDrugImportsService);
  private router = inject(Router);

  errors: string[] = [];

  onUploadComplete({ clientId, name, upload }: ImportUploadResult) {
    this.ineligibleDrugImportsService.create(clientId, name, upload.signedId).subscribe(
      () => {
        this.router.navigate(['/capture-admin/icc-claims/imports/ineligible-drugs/history']);
      },
      (error: HttpErrorResponse) => {
        this.errors = error.error.errors;
      }
    );
  }

  onUploadStart() {
    this.errors = [];
  }

  public get hasError() {
    return !isEmpty(this.errors);
  }
}
